import React, { useRef, useEffect } from "react";

const OrderImage = ({ orderCode, onImageReady }) => {
  const canvasRef = useRef();
  console.log("orderCode :", orderCode);
  useEffect(() => {
    console.log("orderCode :", orderCode);
    const canvas = canvasRef.current;
    canvas.width = 512;
    canvas.height = 530;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const image = new Image();
    image.src = "../../image/succes.jpg";
    image.onload = () => {
      ctx.drawImage(image, 150, 30, 200, 200);

      ctx.fillStyle = "#000";
      ctx.font = "20px Arial";
      ctx.textAlign = "center";
      ctx.fillText("Votre code de commande est :", canvas.width / 2, 270);

      ctx.font = "bold 40px Arial";
      ctx.fillText(orderCode, canvas.width / 2, 320);

      ctx.font = "16px Arial";
      ctx.fillText(
        "Votre commande a été créée avec succès",
        canvas.width / 2,
        360
      );

      const dataUrl = canvas.toDataURL("image/png");
      console.log("dataUrl", dataUrl);
      onImageReady(dataUrl);
    };
  }, [orderCode, onImageReady]);

  return <canvas ref={canvasRef} style={{ display: "none" }} />;
};

export default OrderImage;
